import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式, 文字列長制限} from '@/type/validation/validator';
import {破棄破損修正候補編集レコード型} from '@/type/destroy/records/modify/破棄破損修正候補編集レコード型';

export default class 破棄破損修正候補編集入力チェッカー {
  単項目チェック結果: Error[] = [];
  相関チェック結果: Error[] = [];

  constructor(target: 破棄破損修正候補編集レコード型[], バラ管理である: boolean) {
    if (バラ管理である) {
      const 単項目チェック = new ValidationResult(単項目チェックValidators);
      単項目チェック.validateList(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
      const 払出数エラー = 破棄破損箱数か破棄破損バラ数がゼロ以外(target);
      this.相関チェック結果 = 払出数エラー;
    } else {
      const 単項目チェック = new ValidationResult(箱管理単項目チェックvalidators);
      単項目チェック.validateList(target);
      this.単項目チェック結果 = 単項目チェック.getErrors;
    }
  }

  hasError(name: string, index: number = 0): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === index));
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  errorMessages(): string[] {
    const errorMEssages = this.単項目チェック結果.concat(this.相関チェック結果)
      .sort((a, b) => a.index - b.index)
      .map((value) => `${value.message}`);
    return Array.from(new Set(errorMEssages));
  }
}

const 破棄破損箱数Validator = {
  name: '破棄破損箱数',
  constraints: [
    {method: 必須入力, message: '破棄破損数は入力が必須です'},
    {method: ゼロより大, message: '破棄破損数は0より大きな値にして下さい'},
  ],
};
const 破棄破損日Validator = {
  name: '破棄破損日',
  constraints: [
    {method: 必須入力, message: '破棄破損年月日は入力が必須です'},
    {method: 日付書式, message: '破棄破損年月日の書式を正しく入力してください'},
  ],
};
const 破棄破損理由Validator = {
  name: '破棄破損理由',
  constraints: [
    {method: 必須入力, message: '破棄破損理由を入力してください'},
  ],
};
const 破棄破損コメントValidator = {
  name: '破棄破損コメント',
  constraints: [
    {method: (value: string) => 文字列長制限(value, 100), message: 'コメントは100文字以内で入力してください'},
  ],
};

const 単項目チェックValidators: Validator[] = [
  破棄破損日Validator,
  破棄破損コメントValidator,
  破棄破損理由Validator,
];

const 箱管理単項目チェックvalidators: Validator[] = [
  破棄破損箱数Validator,
  ...単項目チェックValidators,
];

const バラ管理単項目チェックValidators: Validator[] = [
  破棄破損日Validator,
];

function ゼロより大(value: number): boolean {
  return value > 0;
}

function 破棄破損箱数か破棄破損バラ数がゼロ以外(target: 破棄破損修正候補編集レコード型[]): Error[] {
  const errors: Error[] = [];
  target.forEach((value, index): void => {
    if (ゼロより大(value.破棄破損バラ数) || ゼロより大(value.破棄破損箱数)) return;
    errors.push({index, message: '破棄破損数(箱)または破棄破損数(バラ)は0より大きな値にして下さい', constraint: '', name: '破棄破損数エラー'});
  });
  return errors;
}
